import { render, staticRenderFns } from "./caddestaqueprodutos.vue?vue&type=template&id=8c2b7276&"
import script from "./caddestaqueprodutos.vue?vue&type=script&lang=js&"
export * from "./caddestaqueprodutos.vue?vue&type=script&lang=js&"
import style0 from "./caddestaqueprodutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports